import { jsxs, jsx, Fragment } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { BlockNoticeContainer } from "./components/block-notice-container.es.js";
import { BlockNoticeIconContainer } from "./components/block-notice-icon-container.es.js";
import { BlockNoticeTitleContainer } from "./components/block-notice-title-container.es.js";
import { BlockNoticeBodyContainer } from "./components/block-notice-body-container.es.js";
function BlockNotice({
  title,
  body,
  color,
  contrast,
  icon,
  id,
  isMobile
}) {
  const className = `${color} ${contrast}`;
  return /* @__PURE__ */ jsxs(BlockNoticeContainer, { id, className, children: [
    /* @__PURE__ */ jsxs(BlockNoticeTitleContainer, { isMobile, className, "data-testid": "block-notice-title-container", children: [
      icon ? /* @__PURE__ */ jsx(BlockNoticeIconContainer, { children: icon }) : /* @__PURE__ */ jsx(Fragment, {}),
      /* @__PURE__ */ jsx("div", { children: title })
    ] }),
    /* @__PURE__ */ jsx(BlockNoticeBodyContainer, { isMobile, children: body })
  ] });
}
export {
  BlockNotice
};
//# sourceMappingURL=block-notice.es.js.map
